import React from "react";
import {
  Grid,
  Toolbar as MuiToolbar,
  withStyles,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import styles from "./styles";
import ToolBarIcon from "./toolBarIcon";
import OwnershipFilter from "./ownershipFilter";

const Toolbar = (props) => {
  const {
    classes,
    handleZoomIn,
    handleZoomOut,
    resetZoom,
    reload,
    saveAsImage,
    saveAsPdf,
    hideRecords,
    expandAll
  } = props;

  const { t } = useTranslation();

  return (
    <Grid container spacing={2} className={classes.toolbar}>
      <Grid item container xs={4}>
        <OwnershipFilter onChange={hideRecords} />
      </Grid>
      <Grid item container xs={8} justify="flex-end" spacing={2}>
        <MuiToolbar>
          <ToolBarIcon
            title={t("labels.record.ownershipStructure.actions.expandAllParents")}
            iconClass={"fas fa-expand"}
            onClick={expandAll}
          />
          <ToolBarIcon
            title={t("labels.record.ownershipStructure.actions.zoomIn")}
            iconClass={"far fa-search-plus"}
            onClick={handleZoomIn}
          />
          <ToolBarIcon
            title={t("labels.record.ownershipStructure.actions.zoomOut")}
            iconClass={"far fa-search-minus"}
            onClick={handleZoomOut}
          />
          <ToolBarIcon
            title={t("labels.record.ownershipStructure.actions.resetPositions")}
            iconClass={"fas fa-undo"}
            onClick={resetZoom}
          />
          <ToolBarIcon
            title={t("labels.record.ownershipStructure.actions.reload")}
            iconClass={"fas fa-sync-alt"}
            onClick={reload}
          />
          <ToolBarIcon
            title={t("labels.record.ownershipStructure.actions.exportAsPdf")}
            iconClass={"fas fa-download"}
            onClick={saveAsPdf}
          />
        </MuiToolbar>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(Toolbar);
